import { Card, Row, Col, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { IBrandBilling } from "@shared/lib/types/brandBilling";
import styles from "./styles.module.scss";

interface DetailCardProps {
  billing: IBrandBilling;
  onEditClick: () => void;
}

export function DetailCard({ billing, onEditClick }: DetailCardProps) {
  return (
    <Card
      title="Billing Details"
      extra={
        <Button type="text" icon={<EditOutlined />} onClick={onEditClick} />
      }
      className={styles.card}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <div className={styles.label}>Name</div>
          <div className={styles.value}>{billing.name}</div>
        </Col>
        <Col span={12}>
          <div className={styles.label}>GST Number</div>
          <div className={styles.value}>{billing.gst}</div>
        </Col>
        <Col span={24}>
          <div className={styles.label}>Address</div>
          <div className={styles.value}>
            {billing.address.addressLine1}
            <br />
            {billing.address.addressLine2}
            <br />
            {billing.address.city}, {billing.address.state}
            <br />
            {billing.address.country} - {billing.address.pinCode}
          </div>
        </Col>
        <Col span={12}>
          <div className={styles.label}>GST Rate</div>
          <div className={styles.value}>{billing.gstRate}%</div>
        </Col>
        <Col span={12}>
          <div className={styles.label}>Service Charge Rate</div>
          <div className={styles.value}>{billing.serviceChargeRate}%</div>
        </Col>
      </Row>
    </Card>
  );
}
